import { createMuiTheme } from '@material-ui/core';
import React from 'react'
import MuiDialogContent from "@material-ui/core/DialogContent";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import "../../GameInformation/GameInformation.css"

// Define your styles using makeStyles
const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(0),
        // Removed dynamic width calculations here.
        maxWidth: theme.breakpoints.values.md,
        // You might still use minWidth for a minimum width, 
        // but consider if this is necessary given your CSS rules.
    },
}));

// Create your component
const DialogContent = (props) => {
    const { modalContent, contentWidth, ...otherProps } = props;
    const classes = useStyles({ contentWidth }); // Pass props to useStyles

    return (
        <MuiDialogContent className={`${classes.root} content`} {...otherProps}>
            {modalContent}
        </MuiDialogContent>
    );
};

export default DialogContent;
